import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { getStatusBadgeColor } from "@/utils/invoiceUtils";
import { EmptyState } from "./EmptyState";

interface Invoice {
  id: string;
  invoice_number: string;
  amount: number;
  due_date: string;
  status: string;
  recipient_email: string;
}

interface InvoiceListViewProps {
  invoices: Invoice[];
  selectedInvoices: string[];
  onSelect: (id: string) => void;
  onCheckboxChange: (checked: boolean, id: string) => void;
  filter: "all" | "scheduled" | "unscheduled" | "paid" | "unpaid" | "recipient";
}

export const InvoiceListView = ({
  invoices,
  selectedInvoices,
  onSelect,
  onCheckboxChange,
  filter,
}: InvoiceListViewProps) => {
  if (invoices.length === 0) {
    return <EmptyState filter={filter} />;
  }

  return (
    <div className="rounded-md border overflow-x-auto w-full">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12">
              <Checkbox
                checked={selectedInvoices.length === invoices?.length}
                onCheckedChange={(checked) => {
                  if (checked && invoices) {
                    onCheckboxChange(true, "all");
                  } else {
                    onCheckboxChange(false, "all");
                  }
                }}
              />
            </TableHead>
            <TableHead>Invoice Number</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Due Date</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Recipient</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invoices?.map((invoice) => (
            <TableRow
              key={invoice.id}
              className="cursor-pointer"
              onClick={() => onSelect(invoice.id)}
            >
              <TableCell>
                <Checkbox
                  checked={selectedInvoices.includes(invoice.id)}
                  onCheckedChange={(checked) => {
                    onCheckboxChange(checked as boolean, invoice.id);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              </TableCell>
              <TableCell>{invoice.invoice_number}</TableCell>
              <TableCell>${invoice.amount}</TableCell>
              <TableCell>
                {new Date(invoice.due_date).toLocaleDateString()}
              </TableCell>
              <TableCell>
                <Badge
                  variant="secondary"
                  className={getStatusBadgeColor(invoice.status)}
                >
                  {invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
                </Badge>
              </TableCell>
              <TableCell>{invoice.recipient_email}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
